import styles from './footer.module.scss';
import { Button } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useTranslation } from 'react-i18next';

const FOOTER_STEP = 'footer_step_key_';

export default function Footer(props) {
  const { t } = useTranslation();
  if (!props.stepsHighlighted || props.stepsHighlighted < 1 || props.stepsHighlighted > 5)
    throw Error(
      'Footer component instantiated with wrong number of steps ' + props.stepsHighlighted,
    );

  return (
    <div className={styles.container}>
      <div className={styles.steps}>
        <div className={styles.lines}>
          <div>{t('common.next')}</div>
          {Array.from({ length: 5 }, (_, i) => i < props.stepsHighlighted).map(
            (isStepHighlighted, idx) => (
              <div
                key={FOOTER_STEP + idx}
                className={
                  isStepHighlighted ? styles.stepHighlighted : styles.stepNotHighlighted
                }></div>
            ),
          )}
        </div>
        <div className={styles.people}>{props.title}</div>
        <div>{props.description}</div>
      </div>
      <div className={styles.buttons}>
        <Button
          data-testid="FooterBackButton"
          className={styles.back}
          size="small"
          variant="contained"
          startIcon={<ArrowBackIosIcon />}
          onClick={props.handleback}
          sx={{ display: !props.handleback ? 'none' : 'inherit' }}>
          {t('common.back')}
        </Button>
        <Button
          data-testid="FooterNextButton"
          className={styles.next}
          size="small"
          variant="contained"
          endIcon={<ArrowForwardIosIcon />}
          onClick={props.handlenext}
          sx={{ display: !props.handlenext ? 'none' : 'inherit' }}>
          {t('common.next')}
        </Button>
      </div>
    </div>
  );
}
